module.exports = __webpack_public_path__ + "img/CRC2_CD8Tex.a93ddf5d.png";